import React, { useEffect, useRef } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Grid, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DefaultUploadFile from "../../../components/default-upload-file";
import { useCadastrosBasicoDispatch, useCadastrosBasicoState } from "../context/cadastros-basico-context";
import { useCadastrosBasicoController } from "../context/cadastros-basico-controller";
import { ACTION_TYPES, FORM_TYPES } from "../context/cadastros-basico-reducer";
import MaskedTextField from "../../../components/masked-text-field";

export const EstruturaGovernamentalForm = () => {
    const { dataRequest, file } = useCadastrosBasicoState();
    const cadastrosBasicoDispatch = useCadastrosBasicoDispatch();
    const { handleOnChangeForm } = useCadastrosBasicoController();

    const firstInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item lg={8}
                    sm={8}
                    xl={8}>
                    <InputLabel>Tipo</InputLabel>
                    <Select
                        size="small"
                        name='select-type'
                        error={dataRequest?.type === undefined || dataRequest?.type === 0 ? true : false}
                        ref={firstInputRef}
                        value={dataRequest?.type}
                        defaultValue={dataRequest?.type}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)}
                        fullWidth
                    >
                        <MenuItem value={undefined} key={0}>
                            <em>Selecionar</em>
                        </MenuItem>
                        <MenuItem value={1} key={1}>
                            Responsável
                        </MenuItem>
                        <MenuItem value={2} key={2}>
                            Departamento
                        </MenuItem>
                    </Select>
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Nome do Responsável ou Departamento</InputLabel>
                    <OutlinedInput
                        size="small"
                        inputProps={{ min: 0 }}
                        error={dataRequest?.person === undefined || dataRequest?.person.length === 0 ? true : false}
                        name="input-person"
                        value={dataRequest?.person}
                        defaultValue={dataRequest?.person}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Horário de Atendimento</InputLabel>
                    <OutlinedInput
                        size="small"


                        inputProps={{ min: 0 }}
                        name="input-openingHours"
                        value={dataRequest?.openingHours}
                        defaultValue={dataRequest?.openingHours}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>E-mail de Contato</InputLabel>
                    <OutlinedInput
                        size="small"


                        inputProps={{ min: 0 }}
                        name="input-email"
                        value={dataRequest?.email}
                        defaultValue={dataRequest?.email}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Telefone de Contato</InputLabel>
                    <MaskedTextField
                        maskType="phone"
                        size="small"
                        name="input-phoneContact"
                        value={dataRequest?.phoneContact}
                        onChange={(e) => {
                            handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)
                        }}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Endereço</InputLabel>
                    <OutlinedInput
                        size="small"


                        inputProps={{ min: 0 }}
                        name="input-address"
                        value={dataRequest?.address}
                        defaultValue={dataRequest?.address}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Biografia</InputLabel>
                    <OutlinedInput
                        size="small"


                        inputProps={{ min: 0 }}
                        rows={10}
                        multiline={true}
                        name="input-biography"
                        value={dataRequest?.biography}
                        defaultValue={dataRequest?.biography}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Competencias e Responsabilidades</InputLabel>
                    <OutlinedInput
                        size="small"


                        inputProps={{ min: 0 }}
                        rows={10}
                        multiline={true}
                        name="input-competence"
                        value={dataRequest?.competence}
                        defaultValue={dataRequest?.competence}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.estruturaGovernametal, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Imagem de Destaque</InputLabel>
                    <DefaultUploadFile
                        setFileUpload={(file) => {
                            cadastrosBasicoDispatch({
                                type: ACTION_TYPES.setFile,
                                payload: file
                            });
                        }}
                        file={file}
                        id="input"
                        extensions={["jpg", "jpeg", "png"]}
                        maxFileSizeMb={10}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}